import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import {IonInput, ModalController, PopoverController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {debounceTime, Subject, takeUntil} from 'rxjs';
import {environment} from 'src/environments/environment';
import {calculateGeoDistance, MapsUtils} from '../../../map/utils/maps';
import {MapsUtils as MapUtils2} from 'src/smoothr-web-app-core/utils/maps-utils';

import {Api} from '../../../smoothr-web-app-core/api/api';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import Address from '../../../smoothr-web-app-core/models/Address';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {TimeUtils} from '../../../smoothr-web-app-core/utils/time-utils';
import {numberToCurrency, sleep, venueAcceptsOrders} from '../../../smoothr-web-app-core/utils/utils';
import {ValidationUtils} from 'src/smoothr-web-app-core/utils/validation-utils';
import {MapPage} from 'src/app/pages/map/map.page';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import {
    CheckDeliveryRadiusModalComponent
} from 'src/app/components/check-delivery-radius-modal/check-delivery-radius-modal.component';
import {
    EnterFoodspotCodeModalComponent
} from 'src/app/components/enter-foodspot-code-modal/enter-foodspot-code-modal.component';
import {FormControl} from '@angular/forms';
import {SearchCity} from 'src/smoothr-web-app-core/models/SearchCity';
import {AnalyticsService} from 'src/smoothr-web-app-core/services/analytics/analytics.service';
import {SwiperOptions} from 'swiper/types';
import {OrderUtils} from "../../../smoothr-web-app-core/utils/order-utils";
import Map = google.maps.Map;
import MapOptions = google.maps.MapOptions;

@Component({
    selector: 'app-map-venue',
    templateUrl: './map-venue.component.html',
    styleUrls: ['./map-venue.component.scss'],
})
export class MapVenueComponent extends RepositoryDirective implements OnInit, AfterViewInit, OnDestroy {
    @Input() showSearchInput = false;
    @Input() showVenueList = true;
    @Input() venueToFirstPositionShortId = '';
    @Input() selectedType: PreorderType;

    @Output() selectType = new EventEmitter<PreorderType>();
    @ViewChild('mapContainer', {static: true})
    mapElement: ElementRef;
    @ViewChild('swiper') slides: ElementRef | undefined;
    map: Map;
    @ViewChild(IonInput, {static: true})
    inputField: IonInput;
    @ViewChild('venueList', {static: false}) venueList;
    public preorderTypes = [PreorderType.TAKE_AWAY, PreorderType.DELIVERY];
    mapOptions: MapOptions = {
        maxZoom: 15,
        minZoom: 5,
        disableDefaultUI: true,
        clickableIcons: false
    };
    clusterer: MarkerClusterer;
    loading = false;
    loadingAddress = false;
    predictions: any[] = [];
    showHint = false;
    searchTerm: string;
    allVenues: Venue[] = [];
    localVenues: Venue[] = [];
    relevantVenues: Venue[] = [];
    selectedVenueForDelivery: Venue;
    showMap = true;
    slidesOpts: SwiperOptions = {
        effect: 'slide',
        centeredSlides: true,
        slidesPerView: 'auto',
        grabCursor: true,
        spaceBetween: 6,
    };
    selectedVenue: Venue;
    MapsUtils = MapsUtils;
    venuesOpeningHours = {};
    private _showPredictions = false;

    showErrorSelectOrderType: boolean = false;
    pt = PreorderType;
    searchCityForm: FormControl = new FormControl('');
    private onDestroy$ = new Subject<void>();
    public cityPrediction: SearchCity[] = [];
    public promoCodeId: string = '';
    public addressForDelivery: Address;
    public searchControl = new FormControl('');
    public copyAllVenues: Venue[] = [];

    constructor(
        private snackbarCtrl: MatSnackBar,
        public repository: RepositoryService,
        private translate: TranslateService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private modalCtrl: ModalController,
        private route: ActivatedRoute,
        private navService: NavigationService,
        private popover: PopoverController,
        private analytics: AnalyticsService
    ) {
        super(repository);
    }

    ngOnChanges() {
        setTimeout(() => {
            this.changeType(this.selectedType);
        })
    }


    static navigate(router: Router) {
        return router.navigateByUrl(MapPage.url);
    }

    ngOnInit() {
        super.ngOnInit();
        this.searchCityForm.valueChanges.pipe(debounceTime(600), takeUntil(this.onDestroy$)).subscribe(v => {
            if (!v) {
                this.resetMap(true);
            } else {
                this.loadCity(v);
            }
        });
        this.map = new Map(this.mapElement.nativeElement, this.mapOptions);
        new Promise<void>(async resolve => {
            await this.fillInPlace(null);
            await this.initAutocomplete();
            resolve();
        });
        this.route.queryParams.subscribe(v => {
            if (v?.preorderType) {
                this.selectedType = v.preorderType;
            }
            if (v?.promoCodeId) {
                this.promoCodeId = v.promoCodeId;
            }
        });
        this.searchControl.valueChanges.pipe(debounceTime(500), takeUntil(this.onDestroy$)).subscribe(searchValue => {
            this.allVenues = this.copyAllVenues.filter(venue => {
                const copyValue = searchValue.toLowerCase();
                return (
                    venue.name.toLowerCase().includes(copyValue) ||
                    venue.readableId.toLowerCase().includes(copyValue) ||
                    venue.city.de.toLowerCase().includes(copyValue) ||
                    venue.postalCode.includes(copyValue) ||
                    venue.street.toLowerCase().includes(copyValue)
                );
            });
            this.resetMap()
        });
        this.resetMap();
    }

    ngAfterViewInit() {
    }

    async updateSwiperValue() {
        if (this.slides?.nativeElement) {
            const swiperElement = this.slides.nativeElement;
            console.log('AFTER VIEW', this.slides.nativeElement, swiperElement);

            if (swiperElement.swiperParams) {
                Object.assign(swiperElement, this.slidesOpts);
                await sleep(500);
                swiperElement.swiper.update();
            }
        }
    }

    async loadCity(search: string) {
        try {
            const city = await Api.loadCitiesFromService(search);
            this.cityPrediction = city;
        } catch (e) {
        }
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    async resetMap(ignoreExistingOfVenue: boolean = false) {
        if ((this.allVenues.length === 0 && !this.searchControl.value) || ignoreExistingOfVenue) {
            try {
                this.allVenues = (await Api.getAllVenues(environment.customerGroup)).data
                    .filter(
                        ven =>
                            ven.isPublished &&
                            (venueAcceptsOrders(ven, PreorderType.DELIVERY) || venueAcceptsOrders(ven, PreorderType.TAKE_AWAY))
                    )
                    .map(ven => {
                        this.venuesOpeningHours[ven._id] = [...ven.openingHours];
                        try {
                            ven.openingHours = TimeUtils.sanitizeHours(ven.openingHours, ven.specialOpeningHours ?? []);
                            ven.deliveryHours = TimeUtils.sanitizeHours(ven.deliveryHours);
                        } catch (e) {
                            console.error({
                                message: 'Error while sanitizing hours ' + e,
                                venue: ven.name + ' ' + ven.readableId,
                                openingHours: ven.openingHours,
                                deliveryHours: ven.deliveryHours,
                            });
                        }
                        return ven;
                    })
                    .sort((a, b) => {
                        const nameA = a?.name?.replace('Dean & David', '')?.trim();
                        const nameB = b?.name?.replace('Dean & David', '')?.trim();
                        return nameA?.localeCompare(nameB);
                    });

                if (this.address) {
                    this.allVenues = this.allVenues.sort((a, b) => {
                        return (
                            calculateGeoDistance(this.address.lat, this.address.lng, a.location.coordinates[1], a.location.coordinates[0]) -
                            calculateGeoDistance(this.address.lat, this.address.lng, b.location.coordinates[1], b.location.coordinates[0])
                        );
                    });
                }
                this.copyAllVenues = this.allVenues;
                this.allVenues = this.allVenues.filter(it => it.readableId != 'dispatch_test_dnd_frei_komtur');
                console.log('ALL VENUES', this.allVenues);
                this.updateSwiperValue();
            } catch (e) {
            }
        } else if (this.address && this.selectedType !== PreorderType.DELIVERY) {
            this.allVenues = this.allVenues.sort((a, b) => {
                return (
                    calculateGeoDistance(this.address.lat, this.address.lng, a.location.coordinates[1], a.location.coordinates[0]) -
                    calculateGeoDistance(this.address.lat, this.address.lng, b.location.coordinates[1], b.location.coordinates[0])
                );
            });
            this.initRelevantVenues()
            this.setupMap(this.relevantVenues[0]);
            return;
        }
        this.initRelevantVenues();
        await this.setupMap(null);
    }

    initRelevantVenues() {
        this.relevantVenues = this.address && this.selectedType === PreorderType.DELIVERY && this.localVenues?.length != 0
            ? this.localVenues
            : this.selectedType === PreorderType.INSIDE || this.selectedType === PreorderType.TAKE_AWAY
                ? this.allVenues.filter(it => venueAcceptsOrders(it, this.selectedType, false, null, this.venuesOpeningHours[it._id]))
                : this.allVenues;

    }

    public async showItem(selectedVenue: Venue, event: any) {
        // let isVenueOpenValue = true;
        // try {
        // 	isVenueOpenValue = isVenueOpen(selectedVenue);
        // } catch (e) {}
        // console.log('is venue open', isVenueOpenValue, selectedVenue.name);
        // const result = await ShowOnMapVenueDialogComponent.show(this.popover, {
        // 	title: selectedVenue.name,
        // 	event,
        // 	isVenueOpen: isVenueOpenValue,
        // });
        // console.log(result);
        // if (result) {
        this.selectVenue(selectedVenue, this.selectedType);
        // }
    }

    async setupMap(selectedVenue: Venue) {
        if (this.loading) {
            return;
        }
        this.selectedVenue = selectedVenue;
        console.log(this.selectedVenue, selectedVenue);
        this.loading = true;
        this.cdr.detectChanges();
        this.clusterer = MapsUtils.addVenuesToMap(
            this.clusterer,
            selectedVenue,
            this.relevantVenues,
            this.map,
            this.popover,
            venue => this.setupMap(venue),
            (selectedVenue, event) => this.showItem(selectedVenue, event)
        );
        if (selectedVenue && selectedVenue.location && selectedVenue.location.coordinates) {
            const selectedIndex = this.relevantVenues.findIndex(ven => ven._id === selectedVenue._id);
            // wait until slides rendered
            this.scrollToVenue(selectedIndex ?? 0);

            await this.slides.nativeElement.swiper.slideTo(selectedIndex);
        }
        this.loading = false;
        this.cdr.detectChanges();
    }

    hidePredictions() {
        setTimeout(() => {
            this._showPredictions = false;
        }, 200);
    }

    showPredictions() {
        this._showPredictions = true;
    }

    async executeSearch() {
        console.log('executeSearch()');
        this.loading = true;
        try {
            const result = await MapUtils2.executeSearch(this.inputField);
            await this.fillInPlace(result);
        } catch (e) {
        }
        this.loading = false;
    }

    resetSearch() {
        console.log('resetSearch()');
        this.searchTerm = '';
        this.predictions = [];
        this.selectedVenueForDelivery = null;
        this.selectedVenue = null;
        if (this.address) {
            this.repository.address.emit(null);
        }
        this.showHint = false;
        this.cdr.detectChanges();
    }

    async fillInPlace(address: Address) {
        console.log('fillInPlace()');
        if (!address) {
            return;
        }
        this.loading = true;
        try {
            this.searchTerm = MapsUtils.checkAddress(address);
            this.loading = false;
            if (this.address !== address) {
                this.repository.address.emit(address);
            }
            await this.onSlideChange();
        } catch (e) {
            console.error(e);
            this.snackbarCtrl.open(this.translate.instant(e), null, {
                duration: 2000,
            });
        }
        this.loading = false;
    }

    async loadVenues(address: Address) {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.cdr.detectChanges();
        this.localVenues = [];
        try {
            this.localVenues = (await this.repository.getVenuesByAddress(environment.customerGroup, address)).filter(it =>
                venueAcceptsOrders(it, PreorderType.DELIVERY)
            );
            if (this.address) {
                this.localVenues = this.localVenues.sort((a, b) => {
                    return (
                        calculateGeoDistance(this.address.lat, this.address.lng, a.location.coordinates[1], a.location.coordinates[0]) -
                        calculateGeoDistance(this.address.lat, this.address.lng, b.location.coordinates[1], b.location.coordinates[0])
                    );
                });
            }
            this.searchTerm = MapsUtils.addressToString(address);
            console.log('LOCAL', this.localVenues);
            if (this.localVenues.length === 0) {
                this.snackbarCtrl.open(
                    this.translate.instant('map_page.no_venues_in_address', {
                        title: this.searchTerm,
                    }),
                    null,
                    {
                        duration: 2000,
                    }
                );
                this.loading = false;
                await this.resetMap();
                this.cdr.detectChanges();
                return;
            }
            if (this.selectedVenueForDelivery) {
                const deliveryVenues = this.localVenues.filter(ven => venueAcceptsOrders(ven, PreorderType.DELIVERY));
                const selectedDeliveryVenue = deliveryVenues.find(ven => ven._id === this.selectedVenueForDelivery._id);
                if (selectedDeliveryVenue) {
                    await this.selectVenue(selectedDeliveryVenue, PreorderType.DELIVERY);
                } else {
                    this.snackbarCtrl.open(this.translate.instant('map_page.venue_does_not_delivery_to_address'), null, {duration: 2000});
                }
                this.selectedVenueForDelivery = null;
                this.loading = false;
                this.cdr.detectChanges();
                return;
            }
            this.selectedVenue = null;
            this.loading = false;
            await this.setupMap(this.selectedVenue);
        } catch (e) {
            console.error(e);
        }
        this.loading = false;
        this.cdr.detectChanges();
    }

    async onSlideChange() {
        let index = await this.slides?.nativeElement.swiper.activeIndex;
        console.log('onSlide change', index);

        if (index >= this.relevantVenues.length) {
            index = 0;
        }
        await this.setupMap(this.relevantVenues[index]);
    }

    async selectVenue(venue: Venue, preorderType: PreorderType) {
        if (!this.address &&  preorderType === PreorderType.DELIVERY) return this.showDialogForAddress();

        const order = structuredClone(this.order)

        if (preorderType === PreorderType.DELIVERY) {
            this.order.preorder.street = this.address.street;
            this.order.preorder.city = this.address.city;
            this.order.preorder.number = this.address.number;
            this.order.preorder.postalCode = this.address.postalCode;
            this.order.preorder.country = this.address.country;
            this.order.preorder.lat = this.address.lat;
            this.order.preorder.lng = this.address.lng;
        } else {
            this.order.preorder.street = venue.street;
            this.order.preorder.city = venue.city.de;
            this.order.preorder.number = venue.number;
            this.order.preorder.postalCode = venue.postalCode;
            this.order.preorder.country = venue.country;
        }
        this.order.venue = venue._id;
        this.order.preorder.type = preorderType;
        this.order.table = venue.preorderTable;


        this.repository.onOrderChange(this.order);

        const res = OrderUtils.validateOrder(venue, this.order);
        if (res.movDifference && res.movDifference < 0) {
            await this.router.navigateByUrl(NAVIGATIONURLS.menu(), {replaceUrl: true});
            return this.snackbarCtrl.open(
                this.translate.instant('order.min_price', {amount: numberToCurrency(-res.movDifference, order.currency)}),
                null,
                {duration: 5000}
            );

        }

       // await this.openCheckoutModal()
        this.cdr.detectChanges();
        await this.router.navigateByUrl(NAVIGATIONURLS.menu(), {replaceUrl: true});
    }

    // async openCheckoutModal() {
    //     const res = await CheckoutModalComponent.show(this.modalCtrl, this.analytics, this.order, 0);
    //     if (!res?.data) await this.navService.menu()
    // }

    async initAutocomplete() {
        try {
            // await MapUtils2.initAutocompleteCity(
            // 	this.inputField,
            // 	predictions => {
            // 		console.log('PREV', predictions);
            // 		this.predictions = predictions as any[];
            // 		this.cdr.detectChanges();
            // 	}
            // 	// loading => (this.loadingAddress = loading)
            // );
        } catch (e) {
            console.log(e);
        }

        this.loading = false;
    }

    onAddress() {
        super.onAddress();
        new Promise(async () => {
            if (this.address && this.selectedType === PreorderType.DELIVERY) {
                await this.loadVenues(this.address);
            } else {
                await this.resetMap();
                // this.resetSearch();
            }
        });
    }

    setShowMap(value: boolean) {
        this.showMap = value;
        this.cdr.detectChanges();
    }

    mapPrediction(value: any) {
        console.log(value);
        return 'test';
    }

    async checkAddressDelivery(venue: Venue, address: Address) {
        if (this.localVenues.some(v => v._id === venue._id)) {
            return true;
        }
        if (this.address.number && this.address.city && this.address.street) {
            try {
                const addressValidationResult = ValidationUtils.validateAddress(address, true);
                if (addressValidationResult) {
                    return false;
                }
                if (venue.deliveryByAreas && venue?.deliveryAreas?.length > 0) {
                    return true;
                }
                const delivers =
                    (venue.deliveryByRadius &&
                        calculateGeoDistance(address.lat, address.lng, venue.location.coordinates[1], venue.location.coordinates[0]) <=
                        venue.deliveryRadius) ||
                    (venue.isPostalDelivery && venue.deliveryPostalCodes.includes(address.postalCode));

                if (!delivers) {
                    this.snackbarCtrl.open(this.translate.instant('errors.street_delivery'), null, {
                        duration: 2000,
                    });
                    return false;
                }

                return true;
            } catch (e) {
                console.log(e);
                return false;
            }
        } else {
            return false;
        }
    }

    private async scrollToVenue(index: number) {
        try {
            await this.venueList.scrollToPoint(0, this.venueList.el.children[index].offsetTop - 250, 1000);
        } catch (e) {
        }
    }

    changeType(item: PreorderType) {
        this.showErrorSelectOrderType = false;
        this.selectType.emit(item);
        this.selectedType = item;
        if (item === PreorderType.TAKE_AWAY) {
            this.addressForDelivery = null;
        }
        if (item === PreorderType.FOOD_SPOT) {
            if (!this.repository.customer.dndCompany) {
                this.askFoodSpotCode();
            }
        }

        if (item == PreorderType.DELIVERY) {
            this.showDialogForAddress();
        }
        this.updateSwiperValue();
    }

    async initUserGeo() {
        try {
            const address = await MapsUtils.getUserGeocode();
            this.repository.address.emit(address);
            this.onAddress();
        } catch (e) {
            if (e?.code === GeolocationPositionError.PERMISSION_DENIED) {
                this.snackbarCtrl.open(this.translate.instant('map_page.geo_permission_denied'), null, {
                    duration: 2000,
                });
            }
            console.error(e);
        }
    }

    private _addressDialogOpen = false;

    private async showDialogForAddress() {
        if (this._addressDialogOpen) return;
        this._addressDialogOpen = true;
        try {
            const result = await CheckDeliveryRadiusModalComponent.show(this.modalCtrl, this.address, this.map);
            if (result?.address) {
                this.addressForDelivery = result?.address;
                this.repository.address.emit(result.address);
                this.selectVenue(result.venue, this.selectedType)
            } else {
                return await this.router.navigate(['order-type'])
            }
            this.updateSwiperValue();
        } finally {
            this._addressDialogOpen = false;
        }
    }

    async askFoodSpotCode() {
        try {
            const result = await EnterFoodspotCodeModalComponent.show(this.modalCtrl);
            if (result && result?.openingHours?.length > 0) {
                result.openingHours = TimeUtils.sanitizeHours(result.openingHours);
                this.repository.companyCode$.next(result);
                if (result.venue) {
                    const venue = await this.repository.getVenue(result.venue);
                    await this.selectVenue(venue, PreorderType.FOOD_SPOT);
                    await sleep(200);
                    this.selectedType = null;
                }
            }
        } catch (e) {
        }
    }

    clearDeliveryAddress() {
        this.addressForDelivery = null;
        this.showDialogForAddress();
    }

    goHome() {
        this.navService.home();
    }

    updateSearch($event: string) {
        this.searchControl.patchValue($event);
    }
}
